import React from "react";
import {
  FaMobile,
  FaUsers,
  FaChalkboardTeacher,
  FaHandshake,
  FaHeart,
  FaTools,
  FaArrowUp,
  FaLightbulb,
  FaShieldAlt,
} from "react-icons/fa";

const featuresData = [
  {
    icon: FaUsers,
    title: "Project Collaboration",
    description:
      "Team collaborates on different projects to ensure quality service for the clients.",
  },
  {
    icon: FaChalkboardTeacher,
    title: "Live Session",
    description:
      "Free Workshops and Live Sessions are conducted to spread awareness about Tech Trends.",
  },
  {
    icon: FaHandshake,
    title: "Job Referrals",
    description:
      "Members of AS-Tech Community are referred for different jobs and projects.",
  },
  {
    icon: FaLightbulb,
    title: "Discussion of Social Issues",
    description:
      "Social and economic issues are discussed to sort out the best approach to live in an economy and contributing as a team in society.",
  },
  {
    icon: FaHeart,
    title: "Charity Work",
    description: "Members of AS-Tech are helped in times of need.",
  },
  {
    icon: FaTools,
    title: "Premium Tools & Subscriptions",
    description:
      "Some paid tools are given for free and some are sold cheaply.",
  },
  {
    icon: FaArrowUp,
    title: "Professional Growth Tips",
    description: "Tips & tricks for professional growth are shared.",
  },
  {
    icon: FaLightbulb,
    title: "Ideas & Experiences",
    description:
      "Freelancers exchange their experiences & ideas of growth as a professional.",
  },
  {
    icon: FaShieldAlt,
    title: "Trustable Sourcing",
    description:
      "Members of the AS-Tech Community are trustworthy & authentic.",
  },
];

const Features = () => {
  return (
    <>
      <div className="relative">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <defs>
            <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="black" />
              <stop offset="100%" stopColor="#373AC8" />
            </linearGradient>
          </defs>
          <path
            fill="url(#waveGradient)"
            fillOpacity="1"
            d="M0,224L48,234.7C96,245,192,267,288,266.7C384,267,480,245,576,218.7C672,192,768,160,864,122.7C960,85,1056,43,1152,53.3C1248,64,1344,128,1392,160L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>

        <div className="bg-gradient-to-r from-black to-logo">
          <div className="container mx-auto relative justify-center items-center md:px-24 p-6 text-white">
            <div className="mb-3">
              <h2 className="text-2xl font-bold">OUR MAJOR ACTIVITIES</h2>
              <div className="border-t-4 border-orange-500 mt-2 w-10 rounded-full"></div>
            </div>
            <div className="grid md:grid-cols-3 grid-cols-1">
              {featuresData.map((feature, index) => (
                <div
                  key={index}
                  className="hover:bg-white hover:text-logo rounded-xl p-6"
                >
                  <div className="gap-3 flex items-center">
                    <feature.icon size={30} className="text-yellow-500" />
                    <h2 className="font-bold uppercase">{feature.title}</h2>
                  </div>
                  <p className="text-sm pt-2">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 250">
            <path
              fill="#fff"
              fillOpacity="1"
              d="M0,64L34.3,58.7C68.6,53,137,43,206,42.7C274.3,43,343,53,411,80C480,107,549,149,617,144C685.7,139,754,85,823,85.3C891.4,85,960,139,1029,138.7C1097.1,139,1166,85,1234,64C1302.9,43,1371,53,1406,58.7L1440,64L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z"
            ></path>
          </svg>
        </div>
      </div>
    </>
  );
};

export default Features;
